<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header">
    <div class="page-header-left">
      <h3 class="pr-3">{{ title }}</h3>
    </div>
    <v-breadcrumbs divider="-" :items="breadcrumbs"> </v-breadcrumbs>
  </v-layout>
</template>

<script>
import menu from "@/api/menu";
export default {
  data() {
    return {
      title: ""
    };
  },
  computed: {
    breadcrumbs: function() {
      let breadcrumbs = [];
      var splitedRoute = this.$route.fullPath.split("/");
      splitedRoute.splice(splitedRoute.indexOf(""), 1);
      breadcrumbs.push({
        text:
          "> " +
          splitedRoute[0].charAt(0).toUpperCase() +
          splitedRoute[0].slice(1),
        disabled: false,
        href: "/" + splitedRoute[0]
      });
      return breadcrumbs;
    }
  }
};
</script>
